import React from "react";
import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "./SparaSwitch.module.scss";

const SparaSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: 'var(--spara-primary, #de2c49)',
        '&:hover': {
            backgroundColor: 'var(--spara-primary-soft, rgba(222, 44, 73, 0.08))',
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: 'var(--spara-primary, #de2c49)',
    },
}));

const SparaSwitchComponent = ({
    label,
    subtitle,
    checked,
    onChange,
    disabled,
    labelProps = {},
}) => {
    return (
        <div className={styles.switchContainer}>
            <div className={styles.labelContainer} {...labelProps}>
                {label && <span className={styles.label}>{label}</span>}
                {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
            </div>
            <SparaSwitch checked={checked} onChange={onChange} disabled={disabled} />
        </div>
    );
};

export default SparaSwitchComponent;
